import { defineComponent as _defineComponent } from 'vue'
import { computed, useAttrs } from 'vue'
import CUSkeletonLoaderTextField from '@/components/CUSkeletonLoaderTextField.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CUTextField',
  props: {
  dense: { type: Boolean, default: false },
  skeletonLoader: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
  tabIndex: { type: Number, default: null },
  isFinix: { type: Boolean, default: false }
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const attrs = useAttrs()

const listeners = computed(() => {
  return {
    ...attrs,
    input(event: InputEvent) {
      emit('input', event)
    }
  }
})

return { __sfc: true,props, emit, attrs, listeners, CUSkeletonLoaderTextField }
}

})